import React from 'react';
import { auth } from '../config/supabase';
import { accessBlockMessage, type AccessBlockReason } from '../utils/userAccess';
import './AccessBlocked.css';

interface AccessBlockedProps {
  reason: AccessBlockReason | null;
  storeName?: string | null;
  onBackToAdmin?: () => void;
}

const AccessBlocked: React.FC<AccessBlockedProps> = ({ reason, storeName, onBackToAdmin }) => {
  const { title, message } = accessBlockMessage(reason);

  return (
    <div className="access-blocked">
      <div className="access-blocked-card">
        <div className="access-blocked-icon" aria-hidden="true">
          ⛔
        </div>
        <h2 className="access-blocked-title">{title}</h2>
        {storeName && reason === 'store_inactive' && (
          <p className="access-blocked-store">{storeName}</p>
        )}
        <p className="access-blocked-message">{message}</p>
        {onBackToAdmin ? (
          <button type="button" className="access-blocked-btn" onClick={onBackToAdmin}>
            Volver al admin
          </button>
        ) : (
          <button type="button" className="access-blocked-btn" onClick={() => auth.signOut()}>
            Cerrar sesión
          </button>
        )}
      </div>
    </div>
  );
};

export default AccessBlocked;
